/* eslint-disable import/prefer-default-export */
import { useMemo, useCallback, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { stakingTypes } from './constants';

export const useSelectStakingTypes = () => {
  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const selectedStakingType = useMemo(
    () => params?.stakingType || stakingTypes.ACTIVE,
    [params?.stakingType]
  );
  const setSelectedStakingType = useCallback(
    (stakingType) =>
      history.replace({ pathname: location.pathname.replace(selectedStakingType, stakingType) }),
    [history, location.pathname, selectedStakingType]
  );
  useEffect(() => {
    if (!Object.values(stakingTypes).includes(selectedStakingType)) {
      setSelectedStakingType(stakingTypes.ACTIVE);
    }
  }, [selectedStakingType, setSelectedStakingType]);
  return [selectedStakingType, setSelectedStakingType];
};
